module.exports = __webpack_public_path__ + "static/media/frameworks.0b7373c0.png";